(function () {
	window.addEventListener('DOMContentLoaded', e => {
		const navigationMenu = document.querySelector('.site-header__navigation');
		if (navigationMenu === undefined || navigationMenu === null) return;

		// store all navigation variables if navigation menu present
		const hamburger = document.querySelector('.site-header__menu-toggle'),
			masthead = document.querySelector('.site-header'),
			siteWrapper = document.querySelector('.site-wrapper'),
			// sticky = masthead.classList.contains('site-header--sticky') ? true : false,
			sticky = true,
			menuItems = masthead.querySelectorAll('.menu-item'),
			windowHash = window.location.hash,
			submenuAnchors = document.querySelectorAll('.submenu-anchor');

		menuItems.forEach(menuItem => {
			let link = menuItem.querySelector('a'),
				hash = link.hash;
			if (hash === '') return;
			/**
			 * If the element doesn't exist then don't alter the behaviour
			 */
			if (document.querySelector(hash) == null) return;
			e.preventDefault();
		});

		menuItems.forEach(menuItem => {
			menuItem.addEventListener('click', e => {
				if (window.innerWidth > 1024) return;
				if (menuItem.classList.contains('menu-item-has-children')) return;
				masthead.classList.toggle('site-header--menu-toggle');
			});
		});

		submenuAnchors.forEach(el => {
			el.addEventListener('click', e => {
				masthead.classList.toggle('site-header--menu-toggle');
			});
		});

		/**
		 * Toggle mobile menu icon and navigation menu
		 */
		hamburger.addEventListener('click', e => masthead.classList.toggle('site-header--menu-toggle'));

		/**
		 * Sticky navigation stuff
		 */

		let menuOffset = masthead.offsetTop + masthead.clientHeight - 60;
		const stick = () => {
			if (window.scrollY >= menuOffset) {
				masthead.classList.add('site-header--sticky--height');
			} else {
				masthead.classList.remove('site-header--sticky--height');
			}
		};

		if (sticky) {
			setTimeout(() => {
				stick();
			}, 200);
			window.addEventListener('scroll', stick);
		}
	});
})();
